import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableTree = _resolveComponent("TableTree")!
  const _component_StatisticsBaseSwitchTab = _resolveComponent("StatisticsBaseSwitchTab")!

  return (_openBlock(), _createBlock(_component_StatisticsBaseSwitchTab, {
    mode: "line",
    textTrue: _ctx.firstTitle,
    textFalse: _ctx.secondTitle,
    pdfFirstTitle: _ctx.firstTitle,
    pdfSecondTitle: _ctx.secondTitle
  }, {
    "first-tab": _withCtx(() => [
      _createVNode(_component_TableTree, {
        columns: _ctx.tableConfig.columns,
        storePaths: _ctx.firstStorePaths,
        params: _ctx.filter,
        itemKey: "name"
      }, null, 8, ["columns", "storePaths", "params"])
    ]),
    "second-tab": _withCtx(() => [
      _createVNode(_component_TableTree, {
        columns: _ctx.tableConfig.columns,
        storePaths: _ctx.secondStorePaths,
        pagination: _ctx.tableConfig.pagination,
        params: _ctx.filter,
        itemKey: "name"
      }, null, 8, ["columns", "storePaths", "pagination", "params"])
    ]),
    _: 1
  }, 8, ["textTrue", "textFalse", "pdfFirstTitle", "pdfSecondTitle"]))
}